import React, { useState, useRef, useEffect } from 'react'
import { styled } from 'linaria/react'
import { useSiteSettingsQuery } from '../../../hooks/useSiteSettings'
import RenderCustomElements from '../../CustomElements/RenderCustomElements'
import { VB_CATEGORY_SETTINGS } from '../../CustomElements/elementTypes'
import BlogBanner from '../../Core/Banners/BlogBanner'
import { theme } from '../../Theme'

const Container = styled.div`
   background-color: white;
   width: 100%;

   .custom-elements-wrapper {
      max-width: calc(${theme.breakpoints.xl} + 228px);
      margin: auto;
   }

   .text-container,
   .one-column,
   .four-column,
   .three-column,
   .two-column {
      a {
         color: ${theme.colors.blue};
      }
   }
   
   .product-card {
      border: 1px solid #eeeeee;
      box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.1);
   }
`

const BlogArticle = ({ category, parents }) => {
   const [getSetting, loadingSettings] = useSiteSettingsQuery()
   const items = category?.data?.items
   const categorySettings = items?.find(c => c?.type == VB_CATEGORY_SETTINGS)

   return (
      <>
         <BlogBanner
            category={category}
            parents={parents}
            categorySettings={categorySettings}
         ></BlogBanner>

         <Container className="py-16">
            <div className="custom-elements-wrapper">
               <RenderCustomElements items={items} />
            </div>
         </Container>
      </>
   )
}

export default BlogArticle
